var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col justify-between min-h-screen"},[_c('app-header'),_c('div',{staticClass:"page-wrap"},[_vm._t("default")],2),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }